import grapesJS from 'grapesjs';
import { removeHtmlMetaTag, removeCssMedia, removeCssFontFace, cleanCss } from '../utils';

const svgText = `<svg style="width:48px;height:48px" viewBox="0 0 24 24">
<path fill="currentColor" d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z" />
</svg>`;

const InsuranceCardId = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('InsuranceCardId', {
    label: 'Insurance Card Id',
    content: '<p>{{InsuranceCardId}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const InsuranceMemberId = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('InsuranceMemberId', {
    label: 'Insurance Member Id',
    content: '<p>{{InsuranceMemberId}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const InsuranceMemberName = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('InsuranceMemberName', {
    label: 'Insurance Member Name',
    content: '<p>{{EmployeeName}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const DateOfBirth = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('DateOfBirth', {
    label: 'Date Of Birth',
    content: '<p>{{DateOfBirth}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const Gender = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('Gender', {
    label: 'Gender',
    content: '<p>{{Gender}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const EmployerName = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('EmployerName', {
    label: 'Employer Name',
    content: '<p>{{EmployerCompany}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const OfficeId = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('OfficeId', {
    label: 'Office Id',
    content: '<p>{{OfficeId}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const PolicyNumber = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('PolicyNumber', {
    label: 'Policy Number',
    content: '<p>{{PolicyNumber}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const PolicyPeriod = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('PolicyPeriod', {
    label: 'Policy Period',
    content: '<p>{{PolicyPeriod}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const InsurancePlanName = (editor: grapesJS.Editor) => {
  editor.BlockManager.add('InsurancePlanName', {
    label: 'Insurance Plan Name',
    content: '<p>{{InsurancePlanName}}</p>',
    category: 'E-card items',
    media: svgText
  });
}

const plugins: (string | grapesJS.Plugin<{}>)[] = [
  'gjs-blocks-basic',
  'grapesjs-plugin-forms',
  'grapesjs-component-countdown',
  'grapesjs-plugin-export',
  'grapesjs-tabs',
  'grapesjs-custom-code',
  'grapesjs-touch',
  'grapesjs-parser-postcss',
  'grapesjs-tooltip',
  // 'grapesjs-tui-image-editor',
  'grapesjs-typed',
  'grapesjs-style-bg',
  'grapesjs-preset-webpage',
  InsuranceCardId,
  InsuranceMemberId,
  InsuranceMemberName,
  DateOfBirth,
  Gender,
  EmployerName,
  OfficeId,
  PolicyNumber,
  PolicyPeriod,
  InsurancePlanName,
];

const pluginsOpts: Record<string, any> = {
  'gjs-blocks-basic': { flexGrid: true },
  // 'grapesjs-tui-image-editor': {
  //   script: [
  //     // 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/1.6.7/fabric.min.js',
  //     'https://uicdn.toast.com/tui.code-snippet/v1.5.2/tui-code-snippet.min.js',
  //     'https://uicdn.toast.com/tui-color-picker/v2.2.7/tui-color-picker.min.js',
  //     'https://uicdn.toast.com/tui-image-editor/v3.15.2/tui-image-editor.min.js'
  //   ],
  //   style: [
  //     'https://uicdn.toast.com/tui-color-picker/v2.2.7/tui-color-picker.min.css',
  //     'https://uicdn.toast.com/tui-image-editor/v3.15.2/tui-image-editor.min.css',
  //   ],
  // },
  'grapesjs-tabs': {
    tabsBlock: { category: 'Extra' }
  },
  'grapesjs-typed': {
    block: {
      category: 'Extra',
      content: {
        type: 'typed',
        'type-speed': 40,
        strings: [
          'Text row one',
          'Text row two',
          'Text row three',
        ],
      }
    }
  },
  'grapesjs-preset-webpage': {
    modalImportTitle: 'Import Template',
    modalImportLabel: '<div style="margin-bottom: 10px; font-size: 13px;">Paste here your HTML/CSS and click Import</div>',
    modalImportContent: (editor: any) => {
      const css = cleanCss(editor.getCss());
      const html = editor.getHtml();
      return `
        <!doctype html>
        <html lang="en">
          <head>
            <meta charset="utf-8">
            <style>
            ${removeCssFontFace(removeCssMedia(css))}
            </style>
          </head>
          ${removeHtmlMetaTag(html)}
        </html>`;
    },
  },
};

export { plugins, pluginsOpts };